module.exports = __webpack_public_path__ + "static/img/qq.04a7287f.svg";